import { render, staticRenderFns } from "./ModalWrap.vue?vue&type=template&id=160bc3e8&"
import script from "./ModalWrap.vue?vue&type=script&lang=js&"
export * from "./ModalWrap.vue?vue&type=script&lang=js&"
import style0 from "./ModalWrap.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports